import React, { useContext, useEffect, useState } from "react";

import { useAppStore } from "../../../../../context/store";
import { Dialog, Portal, CloseButton, Button, Field, Input, Textarea, Spinner, Select, createListCollection, HStack, Collapsible, Box, Text, VStack, Table } from "@chakra-ui/react";

import Type from "../../../../../utilies/Types";
import { floatingStyles, showToast } from "../../../../../utilies/Utility";
import { LuArrowDown, LuArrowUp, LuBookText, LuDownload, LuFocus, LuSendHorizontal, LuTrash } from "react-icons/lu";
import { serviceGetLayerFromServer, serviceSaveLayer } from "../../../../../api/services/layer";
import { formatReadableDateTime } from "../../../../../utilies/QueryUtility";
import { showBBoxOnMap } from "../../../../../utilies/ProjectUtility";
import { loadGeojsonTypeAsync } from "../../../../../utilies/loader/LoadGeojson";
import { useMapObjects } from "../../../../../context/MapObjectsContext";

const LayersListFromServer = () => {
  // state
  const showLoadLayersDialog = useAppStore((s) => s.showLoadLayersDialog);
  const userData = useAppStore((s) => s.userData);
  const basicGeojsonStyle = useAppStore((s) => s.basicGeojsonStyle);
  const defaultGeojsonStyle = useAppStore((s) => s.defaultGeojsonStyle);
  const userType = useAppStore((s) => s.userType);
  const defaultOsmStyle = useAppStore((s) => s.defaultOsmStyle);

  // setters / refs
  const setShowLoadLayersDialog = useAppStore.getState().setShowLoadLayersDialog;
  const viewerRef = useAppStore.getState().viewerRef;
  const { mapObjects, setMapObjects, mapObjectsRef } = useMapObjects();
  const originalCameraControls = useAppStore.getState().originalCameraControls;

  const [isFormOpen, setIsFormOpen] = useState(true);
  const [receivedData, setReceivedData] = useState([]);
  const [isProgress, setIsProgress] = useState(false);
  const [cityOptions, setCityOptions] = useState(
    createListCollection({
      items: [
        { label: "", value: "" },
        { label: "Springdale", value: "springdale" },
        { label: "Phoenix", value: "phoenix" },
        { label: "Dallas", value: "dallas" },
        { label: "Sherman", value: "sherman" },
      ],
    }),
  );

  const getCurrentDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  const get30DaysAgoDate = () => {
    const past = new Date();
    past.setDate(past.getDate() - 30);
    return past.toISOString().split("T")[0];
  };

  const formatToEpochSec = (date) => {
    return Math.floor(new Date(`${date}T00:00:00Z`).getTime() / 1000);
  };

  const [data, setData] = useState({
    start_time: get30DaysAgoDate(),
    end_time: getCurrentDate(),
    description: "",
    username: "",
    city: "",
    layer_name: "",
  });

  const load = () => {
    setIsProgress(true);
    const formData = new FormData();
    let temp = {};
    for (const key in data) {
      if (data[key]) {
        if (key == "start_time" || key == "end_time") {
          temp[key] = formatToEpochSec(data[key]);
        } else {
          temp[key] = data[key];
        }
      }
    }
    if (!userType.includes(Type.ROLE.SUPER_ADMIN)) {
      temp.username = userData.user.username;
    }
    formData.append("params", JSON.stringify(temp));

    serviceGetLayerFromServer(formData)
      .then((res) => {
        setIsProgress(false);
        if (res.data.status == "success") {
          setReceivedData(res.data.layers);
          setIsFormOpen(false);
        }
      })
      .catch((err) => {
        setIsProgress(false);
        showToast(err.message, Type.NOTIFICATION.WARNING);
        console.error("Error", err);
      });
  };

  const deleteLayer = (item) => {
    const formData = new FormData();
    formData.append("layer_id", item.id);
    formData.append("delete", "true");

    serviceSaveLayer(formData)
      .then((res) => {
        if (res.data.status == "failed") {
          showToast(res.data.message, Type.NOTIFICATION.ERROR);
        } else {
          showToast(res.data.message, Type.NOTIFICATION.SUCCESS);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  };

  return (
    <Dialog.Root
      closeOnInteractOutside={false}
      modal={false}
      placement={"top"}
      scrollBehavior="inside"
      motionPreset="slide-in-right"
      open={showLoadLayersDialog}
      onOpenChange={(e) => {
        setShowLoadLayersDialog(e.open);
      }}
    >
      <Portal>
        <Dialog.Positioner pointerEvents="none">
          <Dialog.Content maxHeight={"calc(100% - 100px)"} mr={"70px"} width={"fit-content"} pointerEvents="all">
            <Dialog.Header>
              <VStack>
                <Dialog.Title width={"full"}> Load Layers From Server </Dialog.Title>
                <Text>This form displays the list of saved layers available on the server</Text>
              </VStack>
            </Dialog.Header>
            <Dialog.Body>
              <Collapsible.Root
                open={isFormOpen}
                onOpenChange={(e) => {
                  setIsFormOpen(e.open);
                }}
              >
                <Collapsible.Trigger variant="outline" size={"2xl"} p={2} mb={1} cursor={"pointer"} width={"full"} bg={"blackAlpha.200"} borderRadius={"md"}>
                  <HStack justifyContent={"space-between"}>
                    <HStack gap={2}>
                      <LuBookText size={20} />
                      <Text fontSize={"17px"}>Form</Text>
                    </HStack>
                    {isFormOpen ? <LuArrowUp size={20} /> : <LuArrowDown size={20} />}
                  </HStack>
                </Collapsible.Trigger>
                <Collapsible.Content>
                  <Box padding="4" borderWidth="1px">
                    <HStack gap={2} mb={2}>
                      <Field.Root>
                        <Field.Label>From Date </Field.Label>
                        <Input
                          value={data.start_time}
                          type="date"
                          placeholder="From Date"
                          onChange={(v) => {
                            setData((prev) => ({
                              ...prev,
                              start_time: v.target.value,
                            }));
                          }}
                        />
                      </Field.Root>
                      <Field.Root>
                        <Field.Label>To Date </Field.Label>
                        <Input
                          value={data.end_time}
                          type="date"
                          placeholder="To Date"
                          onChange={(v) => {
                            setData((prev) => ({
                              ...prev,
                              end_time: v.target.value,
                            }));
                          }}
                        />
                      </Field.Root>
                    </HStack>
                    <HStack gap={2} mb={2}>
                      <Field.Root>
                        <Field.Label>Descrption</Field.Label>
                        <Textarea
                          value={data.description}
                          rows={2}
                          placeholder="Descrption ..."
                          variant="outline"
                          onChange={(v) => {
                            setData((prev) => ({
                              ...prev,
                              description: v.target.value,
                            }));
                          }}
                        />
                      </Field.Root>
                    </HStack>
                    <HStack gap={2} mb={2}>
                      {userType.includes(Type.ROLE.SUPER_ADMIN) && (
                        <Field.Root>
                          <Field.Label>Username</Field.Label>
                          <Input
                            value={data.username}
                            type="text"
                            placeholder="Username"
                            onChange={(v) => {
                              setData((prev) => ({
                                ...prev,
                                username: v.target.value,
                              }));
                            }}
                          />
                        </Field.Root>
                      )}

                      <Field.Root>
                        <Field.Label>Layer Name</Field.Label>
                        <Input
                          value={data.layer_name}
                          type="text"
                          placeholder="Layer Name"
                          onChange={(v) => {
                            setData((prev) => ({
                              ...prev,
                              layer_name: v.target.value,
                            }));
                          }}
                        />
                      </Field.Root>
                    </HStack>
                    <HStack gap={2} mb={2} mt={5}>
                      <Field.Root>
                        <Box pos="relative" w="full">
                          <Select.Root
                            collection={cityOptions}
                            defaultValue={[data.city]}
                            size="sm"
                            width="full"
                            onValueChange={(v) => {
                              setData((prev) => ({
                                ...prev,
                                city: v.value[0],
                              }));
                            }}
                          >
                            <Select.HiddenSelect />

                            <Select.Control>
                              <Select.Trigger>
                                <Select.ValueText placeholder={"city"} />
                              </Select.Trigger>
                              <Select.IndicatorGroup>
                                <Select.ClearTrigger />
                                <Select.Indicator />
                              </Select.IndicatorGroup>
                            </Select.Control>

                            <Select.Positioner>
                              <Select.Content>
                                {cityOptions.items.map((item) => (
                                  <Select.Item item={item} key={item.value}>
                                    {item.label}
                                    <Select.ItemIndicator />
                                  </Select.Item>
                                ))}
                              </Select.Content>
                            </Select.Positioner>
                          </Select.Root>
                          <Field.Label css={floatingStyles}>City</Field.Label>
                        </Box>
                      </Field.Root>
                    </HStack>

                    <Button onClick={load} disabled={isProgress}>
                      {isProgress ? (
                        <Spinner size={"sm"} />
                      ) : (
                        <>
                          <LuSendHorizontal /> Submit
                        </>
                      )}
                    </Button>
                  </Box>
                </Collapsible.Content>
              </Collapsible.Root>
              <Box maxHeight={"600px"} overflowY="auto" mt={4}>
                <Table.Root size="sm" striped>
                  <Table.Body>
                    {receivedData.map((item, index) => (
                      <Table.Row key={index}>
                        <Table.Cell textAlign="start">
                          <Text>Layer Name: {item.layer_name}</Text>
                          <Text>Modified Time: {formatReadableDateTime(item.modified)}</Text>
                          <Text>Layer Type: {item.layer_type}</Text>
                          <Text>Geometry Type: {item.geometry_type}</Text>
                          {item.description && <Text>Descrption: {item.description}</Text>}
                          {item.city && <Text>City: {item.city}</Text>}
                          <Text>Owner: {item.username}</Text>
                        </Table.Cell>

                        <Table.Cell textAlign="end">
                          <Button
                            size="sm"
                            p={0}
                            variant="outline"
                            colorScheme="blue"
                            outline="none"
                            border="none"
                            onClick={() => {
                              fetch("https://matrix.gatik.ai" + item.file_url)
                                .then((response) => response.json())
                                .then((data) => {
                                  loadGeojsonTypeAsync({
                                    originalCameraControls,
                                    geojsonData: data,
                                    fileName: item.layer_name,
                                    viewerRef,
                                    setMapObjects,
                                    defaultGeojsonStyle,
                                    basicGeojsonStyle,
                                    serverLayerId: item.id,
                                    projectId: null,
                                    defaultOsmStyle,
                                  });
                                })
                                .catch((error) => console.error(error));
                            }}
                          >
                            <LuDownload />
                          </Button>
                          <Button
                            size="sm"
                            p={0}
                            variant="outline"
                            colorScheme="blue"
                            outline="none"
                            border="none"
                            onClick={() => {
                              showBBoxOnMap(viewerRef.current, item.bbox);
                            }}
                          >
                            <LuFocus />
                          </Button>
                          <Button
                            size="sm"
                            p={0}
                            variant="outline"
                            colorScheme="blue"
                            outline="none"
                            border="none"
                            onClick={() => {
                              deleteLayer(item);
                            }}
                          >
                            <LuTrash color="red" />
                          </Button>
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table.Root>
              </Box>
            </Dialog.Body>

            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default LayersListFromServer;
